import { render } from "./SmsWallet.vue?vue&type=template&id=5d0051c8&scoped=true"
import script from "./SmsWallet.vue?vue&type=script&lang=js"
export * from "./SmsWallet.vue?vue&type=script&lang=js"

import "./SmsWallet.vue?vue&type=style&index=0&id=5d0051c8&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0051c8"]])

export default __exports__